/* global caiprivacy */
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Button, Glyphicon, ToggledDropdown } from 'reaxl';

/**
 *  Sitemap generates a sitemap in the form of an toggled dropdown for mobile devices and columned link sections for larger viewports
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getColumn = column => [].concat(column);
const renderSitemapItem = (_ref, index, onClick, enableOneTrustFooter) => {
  let {
    callback,
    text,
    pagetype,
    glyph,
    img,
    ...itemRest
  } = _ref;
  const isOneTrust = typeof callback === 'function';

  // If this is a OneTrust-related link but OneTrust is disabled, don't render it
  if (isOneTrust && !enableOneTrustFooter) {
    return null;
  }
  const handleClick = e => {
    const data = {
      type: 'main',
      text,
      pagetype
    };
    if (onClick) {
      onClick(e, data);
    }
    if (callback && typeof caiprivacy !== 'undefined') {
      e.preventDefault();
      callback();
    }
    return true;
  };
  return /*#__PURE__*/_jsx("li", {
    className: "margin-top-2",
    children: isOneTrust ? /*#__PURE__*/_jsxs(Button, {
      ...itemRest,
      onClick: handleClick,
      bsStyle: "text",
      children: [text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
        className: "margin-left-2",
        glyph: glyph
      })]
    }) : /*#__PURE__*/_jsxs("a", {
      ...itemRest,
      ...(onClick && {
        onClick: handleClick
      }),
      className: "link-undecorated",
      children: [text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
        className: "margin-left-2",
        glyph: glyph
      })]
    })
  }, `${itemRest.href || text}/${pagetype}-${index}`);
};
const renderSingleDropdown = (_ref2, onClick, enableOneTrustFooter) => {
  let {
    title,
    items
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: "dropdown",
    children: /*#__PURE__*/_jsx(ToggledDropdown, {
      containerElement: "div",
      collapseElement: "ul",
      collapseClassName: "list-unstyled",
      className: "dropdown-panel-content",
      showCaret: false,
      labelText: title,
      id: title.replace(/\s/ig, ''),
      closeGlyph: "menu-up",
      openGlyph: "menu-down",
      children: items.map((item, index) => renderSitemapItem(item, index, onClick, enableOneTrustFooter))
    }, title.replace(/\s/ig, ''))
  }, title);
};
const renderColumns = (data, colNumber, onClick, enableOneTrustFooter) => data.map((column, index) => /*#__PURE__*/_jsx("div", {
  className: `sitemap-column col-sm-${colNumber}`,
  children: getColumn(column).map(item => renderSingleDropdown(item, onClick, enableOneTrustFooter))
}, `column-${index}-${colNumber}`));
function StaticSitemap(_ref3) {
  let {
    data = [],
    onClick,
    className,
    enableOneTrustFooter,
    ...rest
  } = _ref3;
  const colNumber = Math.round(12 / data.length);
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "sitemap",
    "data-testid": "sitemap",
    className: clsx('sitemap display-flex gap-sm-5 flex-column row flex-sm-row', className),
    ...rest,
    children: renderColumns(data, colNumber, onClick, enableOneTrustFooter)
  });
}
export default StaticSitemap;